import React from 'react'

import { Colors, Dropdown, ToolbarButton, useMediaQueryContext } from '@fourthwall/components'
import { DotsHorizontalIcon } from '@fourthwall/icons'

import type { TeamMemberItem } from '../../Team.types'

export type TeamMemberDropdownProps = {
  teamMember: TeamMemberItem
  onResendInvitation: (invitationId: string) => void
  onInvitationCancel: (invitedUserEmail: string) => void
  onUserRemove: (email: string, fullName?: string) => void
  onChangeRole: (role: string, email: string, fullName?: string) => void
}

export const TeamMemberDropdown = ({
  teamMember,
  onResendInvitation,
  onInvitationCancel,
  onUserRemove,
  onChangeRole,
}: TeamMemberDropdownProps) => {
  const media = useMediaQueryContext()

  if (!teamMember.permissions || !Object.values(teamMember.permissions).filter(Boolean).length) {
    return null
  }

  return (
    <Dropdown
      content={
        <>
          {teamMember.permissions.resendInvitation && (
            <Dropdown.Item
              label="Resend invitation"
              onClick={() => onResendInvitation(teamMember.invitationId!)}
            />
          )}
          {teamMember.permissions.cancelInvitation && (
            <Dropdown.Item
              label="Cancel invitation"
              onClick={() => onInvitationCancel(teamMember.email!)}
            />
          )}
          {teamMember.permissions.changeRole && (
            <Dropdown.Item
              label="Change role"
              onClick={() => onChangeRole(teamMember.role!, teamMember.email!, teamMember.name)}
            />
          )}
          {teamMember.permissions.remove && (
            <Dropdown.Item
              label={teamMember.isYou ? 'Leave' : 'Remove'}
              onClick={() => onUserRemove(teamMember.email!, teamMember.name)}
            />
          )}
        </>
      }
      position="bottom-end"
    >
      <ToolbarButton
        label="Settings"
        placement="top"
        icon={DotsHorizontalIcon}
        color={media.tablet ? undefined : Colors.GS600}
      />
    </Dropdown>
  )
}
